import type { Language } from "../../contexts/LanguageContext";

export function centsToCurrency(cents: number | null | undefined, lang: Language) {
  const v = (cents || 0) / 100;
  const locale = lang === "pt" ? "pt-BR" : "en-US";
  const currency = lang === "pt" ? "BRL" : "USD";
  try {
    return v.toLocaleString(locale, { style: "currency", currency });
  } catch {
    const symbol = lang === "pt" ? "R$" : "$";
    return `${symbol} ${v.toFixed(2)}`;
  }
}

export function parseMoneyToCents(input: string): number {
  const clean = String(input || "").replace(/[^0-9,\.]/g, "").replace(/,/g, ".");
  const num = parseFloat(clean || "0");
  if (!isFinite(num) || isNaN(num)) return 0;
  const cents = Math.round(num * 100);
  return Math.max(0, cents);
}
